module.exports = __webpack_public_path__ + "img/description3.af9e00bd.jpg";